import React from "react";
import { PaymentSvg } from "../../components/Assets";
import TopPageBack from "../../components/TopPageBack";
import { useNavigate } from "react-router-dom";
import { ROUTE_PATHS } from "../../constants/Router";

const HistoryPayment = () => {
  const navigate = useNavigate();
  const onBack = () => {
    navigate(ROUTE_PATHS.More);
  };
  return (
    <div>
      <TopPageBack onBack={onBack}>
        <b style={{ fontSizea: "16px" }}>납부 관리</b>
      </TopPageBack>
      <div
        style={{
          height: "calc(100vh - 100px)",
        }}
        className="flex flex-col justify-center items-center w-screen h-screen"
      >
        <div>
          <img src={PaymentSvg} alt="payment" />
        </div>
        <div style={{ fontSize: "18px" }} className="font-bold mt-7 mb-5">
          관리가 필요한 납부 내용이 없어요.
        </div>
        <div className="mb-2.5">무료 서비스를 이용하시는 경우</div>
        <div>납부 정보가 없을 수 있어요.</div>
      </div>
    </div>
  );
};

export default HistoryPayment;
